import { FeedbackCard } from '@/components/feedback_card';
import ProductCard from '@/components/productCard';
import { ProductState, ProductType } from '@/components/productCard/index.interface';
import { useTranslation } from '@/i18n/client';
import { getPromotionObj } from '@/utils/tracksUtils';
import style from './index.module.scss';
interface IExtraTrack {
  keyWord: string;
  categoryId: string;
  logid: string;
  pvid: string;
  request_id: string;
  mtest: string;
  channelName: string;
  foreLabel: string;
  labelWords: string;
  batchId: string;
  ShipmentType: string;
  pageCode: string;
  Mini_Hp_Name: string;
  mainskuid: string;
  NormalizedKey: string;
  QPParsedLanguage: string;
}
interface productTrackParamsType {
  RecomSku_Expo?: string;
  RecomSku_Addcart_Expo?: string;
  productClick?: (json_param: any) => void;
  addCartClick?: (json_param: any) => void;
  tab_name?: string;
  extraParams?: Partial<IExtraTrack>;
}
interface IProps {
  from?: string;
  products?: any[]; //渲染的商品列表
  localInfo?: any; //本地信息，主要用其中的货币单位
  addCartFn?: Function; //商卡加车回调方法(未加车)
  onAddCartSuccess?: Function; // 商卡--加车成功后--回调
  productTrackParams?: productTrackParamsType; //埋点传参
  shipmentType?: string;
  shouldShowModal?: boolean; //加车是否弹出规格弹窗
  shouldShowService?: boolean; //加车是否弹出服务弹窗
  userInfo?: { isMember?: boolean }; //用户信息
}
const ProductList = (props: IProps) => {
  const { t } = useTranslation();

  const {
    from,
    products = [],
    localInfo = {},
    addCartFn,
    onAddCartSuccess,
    productTrackParams,
    shipmentType,
    shouldShowModal,
    shouldShowService,
    userInfo,
  } = props;

  //统一处理推荐埋点参数
  const { extraParams } = productTrackParams || {};
  const {
    keyWord = '-100',
    categoryId = '-100',
    logid = '-100',
    pvid = '-100',
    request_id = '-100',
    mtest = '-100',
    channelName = '-100',
    foreLabel = '-100',
    labelWords = '-100',
    batchId = '-100',
    pageCode = '-100',
    Mini_Hp_Name = '-100',
    mainskuid = '-100',
    ShipmentType = '-100',
    NormalizedKey = '-100',
    QPParsedLanguage = '-100',
  } = extraParams || {};

  const getJsonParam = (item: any, index: number, isProduct: boolean) => {
    const jsonParams = {
      broker_info: item?.brokeInfo || '-100',
      page: Math.floor(index / 20) + 1,
      index,
      skuid: String(item?.skuId) || '-100',
      p: '-100',
      secprice: item?.content?.originalPrice || '-100',
      secpricetype: '83',
      firprice: item?.content?.realPrice || '-100',
      firpricetype: '11',
      source: '-100',
      freqTag: '-100',
      feedspos: '-100',
      tab_name: productTrackParams?.tab_name,
      filter_name: '-100',
      // 新增参数
      pos: index,
      ShipmentType: ShipmentType || '-100',
      expotime: '0',
      // 包邮页新增参数
      ...(extraParams
        ? {
            keyWord,
            categoryId,
            logid,
            request_id: logid,
            pvid,
            mtest,
            channelName,
            foreLabel,
            labelWords,
            batchId,
            pageCode,
            Mini_Hp_Name,
            mainskuid,
            NormalizedKey,
            QPParsedLanguage,
          }
        : {}),
      // 促销参数
      ...getPromotionObj(item?.content?.promotions),
    };
    if (isProduct) {
      return {
        ...jsonParams,
        rankId: item?.eventTrackMap?.rankId || '-100',
        rankNum: item?.eventTrackMap?.rankNum || '-100',
        rankName: item?.eventTrackMap?.rankName || '-100',
      };
    } else {
      return jsonParams;
    }
  };

  if (products && products.length > 0) {
    return (
      <div className={style.productList}>
        {products &&
          products?.length > 0 &&
          products.map((product: any = {}, index: number) => {
            //type 商卡类型（“0”正常商卡，“1”广告位,  “2”反馈展示商卡）
            if (product.type === '0') {
              return (
                <ProductCard
                  key={`${product.type}_${product.skuId}_${index}`}
                  productData={{
                    from,
                    type: ProductType.TYPE_3,
                    width: 240,
                    productState:
                      product?.wareInStock === '1'
                        ? ProductState.IN_STOCK
                        : ProductState.OUT_OF_STICK,
                    skuName: product?.content?.wareName,
                    skuImgKeyParams: {
                      imgUrlKey: product?.content?.imageUrl,
                      width: 200,
                      height: 200,
                      quality: 100,
                    },
                    unitPriceText: product?.content?.unitPrice,
                    shipmentType,
                    onClickCart: addCartFn,
                    onAddCartSuccess: onAddCartSuccess,
                    currency: localInfo?.currency,
                    languageCode: localInfo?.languageCode,
                    skuId: product.skuId,
                    containerStyle: { backgroundColor: '#fff' },
                    shouldShowCart: true,
                    shouldShowModal: shouldShowModal,
                    shouldShowService: shouldShowService,
                    score: product?.content?.commentScore,
                    isWish: product?.userFavorites,
                    presellInfo: product?.preSellVO,
                    isPromotion: product?.content?.isPromotion,
                    trackingPointParams: {
                      productExpConfig: {
                        event_id: productTrackParams?.RecomSku_Expo,
                        config: {
                          useClick: false,
                          stay_duration: 0.3,
                          repeated: false,
                          area_rate: 0.5,
                        },
                        json_param: getJsonParam(product, index, true),
                      },
                      cartExpConfig: {
                        event_id: productTrackParams?.RecomSku_Addcart_Expo,
                        config: {
                          useClick: false,
                          stay_duration: 0.3,
                          repeated: false,
                          area_rate: 0.5,
                        },
                        json_param: getJsonParam(product, index, false),
                      },
                      productClickPoint: () => {
                        productTrackParams &&
                          productTrackParams.productClick &&
                          productTrackParams.productClick(getJsonParam(product, index, true));
                      },
                      cartClickPoint: () =>
                        productTrackParams &&
                        productTrackParams.addCartClick &&
                        productTrackParams.addCartClick(getJsonParam(product, index, false)),
                    },
                    isMember: userInfo?.isMember,
                    memberPrice: product?.content?.plusPrice,
                    memberPriceDesc: product?.content?.plusPriceDesc,
                    memberPriceIcon: product?.content?.plusLogoUrl,
                    ...product.content,
                  }}
                />
              );
            } else if (product.type === '2') {
              return (
                <FeedbackCard key={`${product.type}_${product.skuId}_${index}`} sourceType={3} />
              );
            }
          })}
      </div>
    );
  } else {
    return null;
  }
};

export default ProductList;
